import {motion as m} from 'framer-motion';
import ScrollToTop from '../../components/ScrollToTop';
import PageHeaderImage from '../../images/pageheader.jpg';
import PageHeader from '../../components/PageHeader';
import {Link} from 'react-router-dom';
import SafeImage from '../../images//homepage-header/Vallan-pest-control.png';
import WhyUs from '../../components/WhyUs';
import ContactCta from '../../components/ContactCta';
import FAQS from '../../components/FAQS';
import './residentialPestControl.css';

const ResidentialPestControl = () => {
    return (
        <m.div 
            initial={{x: "-100%"}}
            animate={{x: "-0%"}}
            transition={{ duration: 0.9, delay:0.7}}
            exit={{opacity: 1}}
        >
            <ScrollToTop />
            <PageHeader title="Residential Pest Control" image={PageHeaderImage}>
                <p>
                    <Link to="/">Home</Link> / <Link to="/services">Services</Link> / Residential Pest Control
                </p>
            </PageHeader>
            <section className='services'>

                <div className="residential-pest-control-services">
                    <div className="container residential-pest-control-content-container">
                        <div className="residential-pest-control-content">
                            <h1>
                                Residential Pest Control
                            </h1>
                            <br />
                            <p>
                                Welcome to PestEX Masters, your go-to pest control company for all your residential pest control needs
                                in Kenya. We understand the frustration and stress that comes with having pests in your home, and
                                that&#39;s why we offer effective and affordable pest control solutions that work. Our team of experienced
                                technicians are trained to handle all kinds of pests, from cockroaches to termites, bed bugs to rodents,
                                and everything in between.
                            </p>
                            <br />
                            <h3>At PestEX Masters, we offer a wide range of residential pest control services to help keep your home
                                pest-free. Here are some of the services we provide:
                            </h3>
                            <br/>
                            <ol>
                                <li>
                                    <p>
                                        Inspection and Assessment - We start by conducting a thorough inspection of your home to
                                        identify the type of pests that are present and the extent of the infestation. We then assess the
                                        level of risk and provide recommendations for the best course of action.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Treatment - Based on our assessment, we design a customized treatment plan that targets the
                                        specific pests in your home. Our treatments are safe for you, your family, and your pets, while
                                        also being effective at eliminating pests.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Follow-up - We don&#39;t just treat your home and leave. We believe in providing ongoing support
                                        to ensure that the pests don&#39;t return. We&#39;ll schedule follow-up visits to monitor the
                                        effectiveness of our treatments and make any necessary adjustments.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Prevention - We also offer preventative services to help you avoid future infestations. We&#39;ll
                                        provide advice on how to keep your home clean and unattractive to pests, as well as perform
                                        regular maintenance checks to ensure that your home stays pest-free.
                                    </p>
                                </li>
                            </ol>
                            <br/>
                            <h3>Why Choose PestEX Masters?</h3>
                            <br/>
                            <ul>
                                <li>
                                    <p>
                                        Experienced and Qualified Technicians - Our technicians are trained and experienced in handling
                                        all types of pests, so you can be sure that your home is in good hands.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Customized Treatment Plans - We don&#39;t believe in a one-size-fits-all approach to pest control.
                                        We design customized treatment plans that are tailored to your specific needs and the type of
                                        pests in your home.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Safe and Effective Treatments - Our treatments are safe for you, your family, and your pets,
                                        while also being effective at eliminating pests.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Affordable Pricing - We offer competitive pricing without compromising on the quality of our
                                        services.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Ongoing Support - We provide ongoing support to ensure that your home stays pest-free.
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="container residential-pest-control-saftey-cont">
                    <div className='saftey'>
                        <div className="container saftey_container">
                            <div className="saftey_header">
                                <h1>We use safe and environmentally friendly measures.</h1>
                                <p>Want to create a pest-free environment without compromising your commitment to sustainability? Our environmentally friendly pest control products are the solution.</p>
                            </div>
                            <div className="saftery_image">
                                <img src={SafeImage} alt="" />
                            </div>
                        </div>
                    </div>
                    <WhyUs />
                    <ContactCta />
                    <FAQS />
                </div>
            </section>
        </m.div>
    )
}

export default ResidentialPestControl